"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cache_1 = require("@almservices-cl/cache");
class Environment {
    getAvailableEnvironments() {
        const environmentObservable = new cache_1.Observable("environment observable");
        environmentObservable.setValue([
            {
                name: "Feature Name",
                endpoint: "https://api.example.com/v1",
                isProduction: false,
            },
            {
                name: "Another Feature Name",
                endpoint: "https://api.example.com/v2",
                isProduction: true,
            },
        ]);
        return environmentObservable;
    }
}
exports.default = Environment;
//# sourceMappingURL=Environment.js.map